import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        typeahead: {type: Boolean, default: false},
        media: {type: Boolean, default: false},
    }

    connect() {

        let backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
            backdrop.remove();
            let body = document.querySelector("body");
        }
        const modal = bootstrap.Modal.getOrCreateInstance(this.element);

        if (modal) modal.show()
        if (this.typeaheadValue === true) {
            init_typeahead();
        }
        if (this.mediaValue === true) {
            MediaCenter.init()
        }
    }

    disconnect() {
        bootstrap.Modal.getInstance(this.element).hide()
    }

}
